// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"b2c1b2db","215":"d431f139","363":"eb41a74b","453":"ecb78a57","457":"5f6ec8e6","764":"7f68bbb5","820":"a0dc53e0","896":"23996e6d"}[chunkId] + ".chunk.js";
};